import { CheckSquare } from "lucide-react";
import { useTranslate } from "ra-core";
import { Card } from "@/components/ui/card";

import { AddTask } from "../tasks/AddTask";
import { TasksListContent } from "../tasks/TasksListContent";

export const TasksList = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center px-1">
        <div className="mr-3 flex size-9 items-center justify-center rounded-xl bg-[#f8e4bd] text-[#9c6820]">
          <CheckSquare className="size-5" />
        </div>
        <div className="flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">
            Focus
          </p>
          <h2 className="text-lg font-semibold tracking-[-0.025em]">
            {translate("crm.dashboard.upcoming_tasks", {
              _: "Upcoming Tasks",
            })}
          </h2>
        </div>
        <AddTask display="icon" selectContact />
      </div>
      <Card className="mb-2 border-[#eadfc7] bg-[#fffdf8] p-4 !text-[#263b39] shadow-[0_12px_26px_rgba(91,68,29,0.06)]">
        <TasksListContent />
      </Card>
    </div>
  );
};
